<template>
  <v-container fluid>
    <v-dialog 
      v-model = "createIntentDialog" 
      width="500">
      <v-card>
        <v-card-title
          class="headline"
          primary-title>
          {{ selected && selected.length && selected.length === 1 ? 'Rename Intent' : 'Create New Intent' }}
        </v-card-title>
        <v-card-text>
          <add-intent
            ref = "addIntent"
            :put = "selected && selected.length && selected.length === 1 ? selected[0] : null"
            @loading = "addButtonLoader = $event"
            @success = "editingDone">
              <label slot = "before-name">Intent Name</label>
              <label slot = "before-culture">Intent Culture</label>
              <label slot = "before-disc">Intent Description</label>
          </add-intent>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            outline
            @click="createIntentDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading = "addButtonLoader"
            color="primary"
            @click="addNewIntent">
            {{ selected && selected.length && selected.length === 1 ? 'Rename' : 'Create' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog 
      v-model = "deleteIntentDialog" 
      width="400">
      <v-card v-if = "selected && selected.length">
        <v-card-title
          class="headline"
          primary-title>
          Delete <span style="padding-left: 5px; font-size: 70%; font-weight: bold"> "{{ selected.length === 1 ?  selected.map(intent => intent.name).join(', ') : '' }}"</span>
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this {{ selected.length > 1 ? selected.length : '' }} Intent{{ selected.length > 1 ? 's' : '' }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :loading = "addButtonLoader"
            color="error"
            outline
            @click="deleteIntents">
            Delete
          </v-btn>
          <v-btn
            color = "black"
            class = "white--text"
            @click="deleteIntentDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout 
      row 
      wrap>
      <h1>My Intents</h1>
      <v-spacer />
      <app-actions show-test/>
    </v-layout>
    <v-flex xs12>
      <v-card class = "card-curvey">
        <v-layout 
          row 
          wrap>
          <v-flex xs4>
            <v-text-field
              v-model = "queries.q"
              placeholder = "Search By Name.."
              intentend-icon = "search"
              outline
              @input="getIntents(true)" />
          </v-flex>
          <v-spacer />
          <v-btn
            :disabled = "!selected || !selected.length || selected.length !== 1"
            :loading = "!!(addButtonLoader && selected.length)"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "openAddDialog(false)">
            <v-icon>edit</v-icon>
            Rename
          </v-btn>
          <v-btn
            :disabled = "!selected || !selected.length || selected.length !== 1"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "syncIntent">
            <v-icon>sync</v-icon>
            Sync
          </v-btn>
          <v-btn
            :disabled = "!selected || !selected.length"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "deleteIntentDialog = true">
            <span 
              class="botter-trash-icon" 
              style="padding-right: 6px"/>
            Delete
          </v-btn>
          <v-btn
            :loading = "!!(addButtonLoader)"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "openAddDialog(true)">
            <v-icon>add</v-icon>
            New Intent
          </v-btn>

        </v-layout>
        <v-flex xs12>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="queriedIntents"
            :loading="loaders.list"
            hide-actions
            item-key="name"
            no-data-text = "No Intents Available"
            single-select
            class="elevation-1 nlp-data-table">
            <template 
              slot="items" 
              slot-scope = "props" > 
              <tr v-if = "props.item.name">
                <td v-if="props.item.name !=='None'">
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                  />
                </td>
                <td v-if="props.item.name ==='None'">
                  <span>
                  </span>
                </td>
                <td>
                  <span
                    class = "primary--text pointer-cursor"
                    @click = "selectIntent(props.item)">
                    {{ props.item.name }}
                  </span>
                  <a :href="`/nlp/app/${$store.state.nlp.selectedApp.id}/intents/${props.item.id}`" target="_blank" class="ml-1">
                    <v-icon color="primary" size="15">open_in_new</v-icon>
                  </a>
                </td>
                <td class="text-center">{{ props.item.intent_samples ? props.item.intent_samples.length : 0 }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-divider />
      <v-layout 
        row 
        wrap >
        <v-flex xs10>
          <v-layout 
            justify-center 
            align-content-center 
            style = "padding-top: 15px">
            <v-pagination
              slot = "footer"
              v-model="pagination.page"
              :length="paginationCount"
              :disabled="loaders.list"
              style = "width: auto !important; margin: auto !important"
              @input = "getIntents(false)" />
          </v-layout>
        </v-flex>
        <v-flex 
          xs2
          align-self-center>
          <v-spacer />
          <div style="text-align: right"><small>Items Per Page</small></div>
          <v-select
            v-model = "pagination.per_page"
            :items = "[5,10,15,20,25]"
            :disabled="loaders.list"
            style="width: 80px; float: right"
            outline
            @input = "getIntents(false)"/>
        </v-flex>
      </v-layout>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import AddIntent from '../../../../components/nlp/intents/AddIntent.vue'
import AppActions from '../../common/AppActions'
export default {
  name: 'NlpIntents',
  components: {
    AddIntent,
    AppActions
  },
  data() {
    return {
      queries: {
        q: ''
      },
      pagination: {
        page: 1,
        per_page: 15
      },
      loaders: {
        list: true
      },
      tableProps: {
        rowsPerPage: 10,
        page: 1
      },
      createIntentDialog: false,
      deleteIntentDialog: false,
      addButtonLoader: false,
      selected: [],
      headers: [
        { text: 'Select', value: 'none', align: 'left', sortable: false},
        {
          text: 'Intent Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Examples', value: 'extra', align: 'center' }
      ]
    }
  },
  computed: {
    queriedIntents() {
      // return this.$store.getters['nlp/intents/query'](this.queries.q)
      return this.$store.state.nlp.intents
    },
    paginationCount() {
      return this.queriedIntents && this.queriedIntents.length
        ? Math.ceil(
            this.$store.state.nlp.intentsPagination.intents.count /
              this.pagination.per_page
          )
        : 0
    }
  },
  watch: {
    // selected: {
    //   deep: true,
    //   handler(val) {
    //     if(val && val.length && val.length > 1) {
    //       this.selected = [val[val.length - 1]]
    //     }
    //   }
    // }
    tableProps: {
      deep: true,
      handler(val) {
        this.asyncLocalStorage(val)
      }
    }
  },
  mounted() {
    // get intents
    this.getIntents()
    this.asyncLocalStorage()
  },
  methods: {
    // cloneIntent() {
    //   this.addButtonLoader = true
    //   const payload = this.$_.pick(this.selected[0], ['name'])
    //   this.$store.dispatch('nlp/intents/add', payload).then(()=>{
    //     this.addButtonLoader = false
    //   }).catch(()=> {
    //     this.addButtonLoader = false
    //   })
    // },
    asyncLocalStorage(payload = null) {
      // if(!payload) {
      //   const stored = window.localStorage.getItem('intentsTable')
      //   if(!stored) {
      //     this.asyncLocalStorage(this.tableProps)
      //   } else {
      //     this.tableProps = JSON.parse(stored)
      //   }
      // } else {
      //   window.localStorage.setItem('intentsTable', JSON.stringify(payload))
      // }
    },
    syncIntent() {
      this.$store.dispatch('setLoader', true)
      this.$store.dispatch('nlp/intents/single/sync', this.selected[0].id).then(()=>{
        this.$store.dispatch('setLoader', false)
      }).catch(()=>{
        this.$store.dispatch('setLoader', false)
        this.$store.dispatch('setErrorMessage', true)
      })
    },
    editingDone()
    { 
      this.createIntentDialog = false;
      this.selected = [];
    },
    getIntents(resetPagination = false) {
      // this.queriedIntents = []
      // this.selected = []
      this.loaders.list = true
      if(resetPagination) {
        this.pagination.page = 1
      }
      let params = { ...this.pagination, hideLoading: true }
      if(this.queries.q && this.queries.q.length) params['filter[name]'] = this.queries.q
      this.$store.dispatch('nlp/intents/get', params)
      .then(()=>{
        this.loaders.list = false
      })
      .catch(err => {
        this.$store.dispatch('setErrorMessage', true)
        this.loaders.list = false
      })
    },
    openAddDialog(reset = true) {
      if(reset)
        this.selected = []
      this.createIntentDialog = true
    },
    addNewIntent() {
      if (this.$refs.addIntent) this.$refs.addIntent.submit()
    },
    selectIntent(intent) {
      this.$store.dispatch('nlp/intents/select', intent)
      this.$router.push(`/nlp/app/${this.$route.params.id}/intents/${intent.id}`)
    },
    deleteIntents() {
      this.$store.dispatch('setLoader', true)
      this.$store
        .dispatch('nlp/intents/delete/multiple', this.selected)
        .then(async () => {
          this.deleteIntentDialog = false
          await this.$store.dispatch('setLoader', false)
          this.$store.dispatch('setSnackbar', {
            text: `Deleted Successfully`,
            color: 'success'
          })
          this.selected = []
        })
        .catch((err) => {
          // console.log(err)
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        })
    },
    // handleTablePagination(e) {
    //   console.log(e)
    //   this.tableProps.itemsPerPage = e.rowsPerPage
    // }
  },
}
</script>

<style lang="scss" src="../../../../assets/sass/commponents/nlp.scss">
</style>
